<template>
  <div class="bg-dark-background grow pt-8 pb-8 lg:flex lg:items-center lg:justify-center">
    <div class="flex flex-col page-container">
      <slot />
    </div>
  </div>
</template>
